'use client';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useDealerLocatorModal } from 'components/dealer-locator/dealer-locator-modal-context';

const WelcomeModal: FC<Readonly<PropsWithChildren>> = ({ children }) => {
  const dealerLocatorModal = useDealerLocatorModal();
  useEffect(() => {
    dealerLocatorModal.modalControl.open();
  }, [dealerLocatorModal.modalControl]);
  return <>{children}</>;
};

export default WelcomeModal;
